import { Input, Modal, Typography } from 'antd'
import type { JSX } from 'react'

type RemoveDomainModalProps = {
  confirmInput: string
  domain: string
  isOpen: boolean
  isRemoving: boolean
  onCancel: () => void
  onConfirm: () => void
  onConfirmInputChange: (value: string) => void
}

export function RemoveDomainModal({
  confirmInput,
  domain,
  isOpen,
  isRemoving,
  onCancel,
  onConfirm,
  onConfirmInputChange,
}: RemoveDomainModalProps): JSX.Element {
  return (
    <Modal
      confirmLoading={isRemoving}
      okButtonProps={{ danger: true, disabled: confirmInput !== domain }}
      okText="Remove"
      onCancel={onCancel}
      onOk={onConfirm}
      open={isOpen}
      title="WARNING"
    >
      <Typography.Paragraph>
        {`This action cannot be undone. Are you sure you want to remove the custom domain "${domain}"?`}
      </Typography.Paragraph>
      <div>
        <Typography.Text>Type &quot;{domain}&quot; to confirm</Typography.Text>
        <Input
          onChange={(event) => onConfirmInputChange(event.target.value)}
          placeholder={domain}
          style={{ marginTop: 8 }}
          value={confirmInput}
        />
      </div>
    </Modal>
  )
}
